export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14563.9e93e3c8.jpg";